import React, { useEffect } from "react";
import "./Versorgungsgebiete.css";
import Header from "../common/header/Header";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const Versorgungsgebiete = () => {
  const cities = [
    "Rodgau",
    "Babenhausen",
    "Dietzenbach",
    "Seligenstadt",
    "Hanau",
    "Rödermark",
    "Hainburg",
    "Obertshausen",
    "Heusenstamm",
    "Eppertshausen",
  ];

  // Koordinaten für die Marker
  const locations = [
    { name: "Rodgau",        coords: [50.0013, 8.8769] },
    { name: "Babenhausen",   coords: [49.9623, 8.9533] },
    { name: "Dietzenbach",   coords: [50.0173, 8.7870] },
    { name: "Seligenstadt",  coords: [50.0437, 8.9711] },
    { name: "Hanau",         coords: [50.1342, 8.9142] },
    { name: "Rödermark",     coords: [49.9729, 8.8302] },
    { name: "Hainburg",      coords: [50.0764, 8.9379] },
    { name: "Obertshausen",  coords: [50.0670, 8.8330] },
    { name: "Heusenstamm",   coords: [50.0555, 8.8010] },
    { name: "Eppertshausen", coords: [49.9485, 8.8439] },
  ];

  // Scroll nach oben + Karte initialisieren
  useEffect(() => {
    window.scrollTo(0, 0);

    const map = L.map("versorgungsgebiete-map").setView([50.01, 8.9], 11);

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 18,
      attribution: "&copy; OpenStreetMap-Mitwirkende",
    }).addTo(map);

    // Marker in Malik-Rot (#E53935)
    locations.forEach((loc) => {
      L.circleMarker(loc.coords, {
        radius: 8,
        color: "#E53935",
        fillColor: "#E53935",
        fillOpacity: 0.85,
      })
        .addTo(map)
        .bindTooltip(loc.name, { direction: "top" });
    });

    // Cleanup, wenn die Seite verlassen wird
    return () => {
      map.remove();
    };
  }, []); // nur einmal beim Mount ausführen

  return (
    <>
      <Header />
      <div className="versorgungsgebiete-wrapper">
        {/* Hero Section */}
        <div className="versorgungsgebiete-hero">
          <div className="hero-content">
            <h1>Unsere Einsatzgebiete</h1>
            <p>
              Wir vom Pflege- und Betreuungsdienst Malik sind stolz darauf, unsere
              Dienstleistungen in Ihrer Nähe anzubieten. Unsere regionalen
              Versorgungsgebiete garantieren kurze Wege, schnelle
              Reaktionsfähigkeit und eine vertraute Betreuung.
            </p>
          </div>
        </div>

        {/* Main Content */}
        <div className="versorgungsgebiete-container">
          {/* Map Section */}
          <section className="map-section">
            <h2>Unsere Versorgungsgebiete auf der Karte</h2>
            <div className="map-wrapper">
              <div className="map-container">
                <div
                  id="versorgungsgebiete-map"
                  className="leaflet-map"
                ></div>
              </div>
              <div className="map-legend">
                <h3>Versorgungsgebiete:</h3>
                <p>Rot markierte Punkte: Unsere Einsatzorte</p>
                <p>Umkreis: ca. 10–15 km rund um Rodgau</p>
              </div>
            </div>
          </section>

          {/* Cities Grid */}
          <section className="cities-section">
            <h2>Alle unsere Versorgungsorte</h2>
            <div className="cities-grid">
              {cities.map((city, index) => (
                <div key={index} className="city-box">
                  <span>{city}</span>
                </div>
              ))}
            </div>
          </section>

          {/* Benefits Section */}
          <section className="benefits-section">
            <h2>Warum unsere regionale Nähe ein Vorteil ist</h2>
            <div className="benefits-grid">
              <div className="benefit-item">
                <h3>Schnelle Erreichbarkeit</h3>
                <p>Wir sind für Sie da, wenn Sie uns brauchen.</p>
              </div>
              <div className="benefit-item">
                <h3>Flexible Tourenplanung</h3>
                <p>Optimale Abstimmung der Pflegeeinsätze für bessere Betreuung.</p>
              </div>
              <div className="benefit-item">
                <h3>Direkter Kontakt</h3>
                <p>Persönliche Ansprechpartner in Ihrer Region.</p>
              </div>
              <div className="benefit-item">
                <h3>Mehr Zeit für Pflege</h3>
                <p>Kurze Fahrtzeiten bedeuten mehr Zeit für Sie.</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default Versorgungsgebiete;
